export default "__VITE_ASSET__C6XvyAa4__"